import { Input, Select } from '@bitcine/cinesend-theme'
import React, { useState } from 'react'
import useStore from '../../../hooks/use_store'

const AirlineValidatorParams = ({ name, data }) => {
  const [value, setValue] = useState(data.parameters?.value)
  const { createModel } = useStore()

  if (!data.parameters || typeof data.parameters != 'object' || Object.keys(data.parameters).length === 0) {
    return ''
  }

  const saveParamsValue = (value) => {
    createModel.mutate({
      endpoint: 'validator-airline-config',
      data: {
        validator_id: data.validator_id,
        airline_id: data.airline_id,
        parameters: {
          options: data.parameters.options,
          value: value,
        },
      },
    })
  }

  // for list return dropdown
  if (data.parameters?.options) {
    return (
      <Select
        id={name}
        options={data.parameters?.options}
        value={data.parameters?.options.find((item) => item.value == value)}
        onChange={(input) => {
          setValue(input.value)
          saveParamsValue(input.value)
        }}
      />
    )
  }

  return (
    <Input name={name} value={value} onChange={(e) => setValue(e.target.value)} onBlur={() => saveParamsValue(value)} />
  )
}

export default AirlineValidatorParams
